import React, { useState } from "react";

interface ImageWithErrorHandlingProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  classes?: string;
}

const ImageWithErrorHandling: React.FC<ImageWithErrorHandlingProps> = ({ src, alt, style, classes }) => {
  const [isError, setIsError] = useState(false);

  const handleError = () => {
    setIsError(true);
  };

  if (isError) {
    return null; // Non renderizza nulla se c'è un errore
  }

  return <img src={src} alt={alt} style={style} className={classes} onError={handleError} />;
};

export default ImageWithErrorHandling;